import { cn } from "../../lib/utils"; 
export const BentoGridGallery = ({ className, children }) => {
  return (
    <div
      className={cn(
        "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 max-w-7xl mx-auto",
        className
      )}
    >
      {children}
    </div>
  );
};

export const BentoGridItemGallery = ({ className, title, description, imageSrc, icon }) => {
  return (
    <div
      className={cn(
        "row-span-1 rounded-xl group/bento hover:shadow-xl transition duration-200 shadow-input dark:shadow-none p-4 bg-white border justify-between flex flex-col space-y-4",
        className
      )}
    >
      {/* Image Wrapper with Aspect Ratio */}
      {imageSrc && (
        <div className="w-full aspect-[3/2] overflow-hidden rounded-xl">
          <img
            loading="lazy"
            src={imageSrc}
            alt="Unser Verein"
            className="w-full h-full object-cover"
          />
        </div>
      )}

      {/* Text Section */}
      <div className="group-hover/bento:translate-x-2 transition duration-200">
        {icon && <div>{icon}</div>}
        {title && (
          <div className="font-sans font-bold text-sky-600 mb-2 mt-2">
            {title}
          </div>
        )}
        {description && (
          <div className="font-sans font-normal text-xs text-gray-400">
            {description}
          </div>
        )}
      </div>
    </div>
  );
};
